import { Injectable } from '@angular/core';
import { default as Prismic } from 'prismic-javascript';
import { from } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { OeAppService } from './oe-app.service';
import { Language } from './types/language';

@Injectable({
  providedIn: 'root',
})
export class PrismicService {
  constructor(private oeApp: OeAppService) {}

  Predicates = Prismic.Predicates;

  getApi() {
    return from(Prismic.getApi(this.oeApp.prismicUrl()));
  }

  query(queries, language: '*' | Language = '*') {
    const prismicLanguage = language === '*' ? '*' : `${language}-oe`;
    return this.getApi().pipe(
      mergeMap((api) => {
        return from(api.query(queries, { lang: prismicLanguage })).pipe(
          map((response) => response.results)
        );
      })
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/prismic.service.ts